import React, { useRef, useState } from 'react';
import { Table } from 'antd';
import {
  Dispatch,
  LinkWithNodes,
  QueryResponse,
  store,
} from '../../utils/types';
import { connect } from 'react-redux';
import { EDGES, getNodeTableColumns } from '../../utils/table-columns';
import { getNodeColor } from '../../utils/helpers';

type Props = {
  tableType: string;
  queryResponse: QueryResponse;
  isClustering: boolean;
  coloredField: any;
};
const TableView = ({
  tableType,
  queryResponse,
  coloredField,
  isClustering,
}: Props) => {
  const searchInputRef = useRef<any>(null);
  const [searchFilter, setSearchFilter] = useState({
    searchText: '',
    searchedColumn: '',
  });

  const dataSource = queryResponse.nodes.map((node: any) => {
    const nodeClone = { ...node };
    if (coloredField) {
      nodeClone.coloredField = coloredField.key;
    }

    nodeClone.color = getNodeColor(nodeClone, coloredField)[0];

    return nodeClone;
  });

  return (
    <div className="p-10">
      {tableType === 'EDGES' && (
        <Table
          rowKey={(link: LinkWithNodes) =>
            link.source.id + '-' + link.target.id
          }
          columns={EDGES(searchFilter, setSearchFilter, searchInputRef)}
          dataSource={queryResponse.links as LinkWithNodes[]}
        />
      )}

      {tableType === 'NODES' && (
        <Table
          rowKey="id"
          scroll={{ x: 400 }}
          columns={getNodeTableColumns(
            queryResponse.nodesInfo,
            searchFilter,
            setSearchFilter,
            searchInputRef
          )}
          dataSource={dataSource}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: store) => ({
  queryResponse: state.query.queryResponse,
  isClustering: state.query.requestedQueryDetails.clustering,
  coloredField: state.graphModals.coloredField,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TableView);
